import classes from './FieldSetCollapseBar.module.scss'
import {
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiChevronUp
} from 'react-icons/fi'
import { IconButton } from '../..'
import { useState } from 'react'
import type { ReactNode } from 'react'

type collapseDirection = 'vertical' | 'horizontal'
export interface Props {
  collapseDirection?: collapseDirection
  children: ReactNode
  defaultCollapse?: boolean
}

const FieldSetCollapseBar = ({
  collapseDirection = 'horizontal',
  children,
  defaultCollapse = false
}: Props) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapse)

  const handleClick = () => {
    setIsCollapsed(!isCollapsed)
  }

  const getClass = () => {
    const isCollapsedClass = isCollapsed
      ? ' ' + classes.collapsedWrapper
      : ''

    const CollapseBarWrapperClass = [
      classes.overflowWrapper,
      isCollapsedClass
    ].filter(classname => classname)

    return CollapseBarWrapperClass.join(' ')
  }

  const title = isCollapsed
    ? 'Expand'
    : 'Collapse'

  return collapseDirection === 'horizontal'
    ? (
      <div className={classes.PanelCollapseBar}>
        {
          isCollapsed
            ? <div className={classes.emptyChildren} />
            : children
        }
        <span
          aria-hidden // There is no need for a screen reader to collapse content
          className={classes.collapseButtonWrapper}
        >
          {
            isCollapsed
              ? (
                <IconButton
                  hasOutline
                  isWhiteBackground
                  onClick={handleClick}
                  title={title}
                >
                  <FiChevronRight />
                </IconButton>
              )
              : (
                <IconButton
                  hasOutline
                  isWhiteBackground
                  onClick={handleClick}
                  title={title}
                >
                  <FiChevronLeft />
                </IconButton>
              )
          }
        </span>
      </div>
    )
    : (
      <div className={classes.PanelCollapseBar}>
        <div
          className={getClass()}
        >
          {children}
        </div>
        <span className={classes.collapseButtonWrapper}>
          <IconButton
            onClick={handleClick}
            title={title}
          >
            {
              isCollapsed
                ? <FiChevronDown />
                : <FiChevronUp />
            }
          </IconButton>
        </span>
      </div>
    )
}

export default FieldSetCollapseBar
